import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ImageBlob } from '../../base/model/features-decl';
import { PhotoWizardResult } from '../photo-wizard/photo-wizard.component';
import { AppContext, WizardContext } from '../../base/control/context';
import { ValidationService } from '../../base/validation/validation.service';

@Component({
  selector: 'i-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
})
export class PhotoComponent {
  @Input() chipImage: string;
  @Input() printImage: string;
  @Output() chipImageChange = new EventEmitter();
  @Output() printImageChange = new EventEmitter();
  @Input() flagsChip: ImageBlob;
  @Input() flagsPrint: ImageBlob;

  get isWizardEnabled$(): boolean {
    return this.isWizardEnabled;
  }

  private isWizardEnabled = false;

  constructor(private appContext: AppContext, private wizardContext: WizardContext, private validationService: ValidationService) {}

  shoot() {
    this.isWizardEnabled = true;
    this.appContext.changeMessageSinkVisibleRef(false);
    this.wizardContext.setToolbarVisible(false);
  }

  clear() {
    this.chipImageChange.emit({});
    this.printImageChange.emit({});
    this.flagsChip.scanned = false;
    this.flagsPrint.scanned = false;
    this.validationService.validate();
  }

  onWizardClosure(result: PhotoWizardResult | null) {
    this.isWizardEnabled = false;
    this.appContext.changeMessageSinkVisibleRef(true);
    this.wizardContext.setToolbarVisible(true);

    if (result) {
      this.chipImageChange.emit({ raw: result.chipPhoto });
      this.printImageChange.emit({ raw: result.portraitPhoto });
      this.flagsChip.scanned = true;
      this.flagsPrint.scanned = true;
      this.validationService.validate();
    }
  }
}
